

exports.__esModule = true;
exports.$UserAgreementConsentModel = undefined;

var _consent = require('./consent');

var CONSENT_USER_AGREEMENT_DEFAULT = {
    activeUrl: '/webapps/mpp/ua/useragreement-full',
    upcomingUrl: '/webapps/mpp/ua/upcoming-policies-full',
    majorVersion: '3',
    minorVersion: '2',
    status: 'PENDING'
};

var $UserAgreementConsentModel = exports.$UserAgreementConsentModel = _consent.$ConsentModel.extend('$UserAgreementConsentModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties(CONSENT_USER_AGREEMENT_DEFAULT);
    }
});

angular.value("$UserAgreementConsentModel", $UserAgreementConsentModel);
_consent.$ConsentModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/consent/userAgreementConsent.js
// module id = ../node_modules/xo-models/src/consent/userAgreementConsent.js
// module chunks = 0